import siteCommon from 'site/site-common'
let siteScroll = {
    cueRevealed: true,
    init:function () {
        ////////////////////////////
        $(window).on("scroll",siteScroll.scroll);
        $(window).on( "resize", siteScroll.scroll);

        //siteScroll.setHeaderPusher(false)
        siteScroll.scroll();

    },//init

    //////////////////////////////////////////////////////////////////////////////////////////
    scroll:function() {
        var scrollTop = $(window).scrollTop();
        var headershrink_h = 0;
        if (scrollTop>headershrink_h) {
            $('body').addClass('miniheader');
        } else {
            $('body').removeClass('miniheader');
        }

        // Fade the hero scroll-cue out as soon as the user scrolls; fade back in at top.
        var shouldReveal = scrollTop <= 0;
        if (shouldReveal !== siteScroll.cueRevealed) {
            siteScroll.cueRevealed = shouldReveal;
            if (window.scrollCue) {
                if (shouldReveal) window.scrollCue.reveal();
                else window.scrollCue.unreveal();
            }
        }
        //siteScroll.setHeaderPusher(true)
    },
}
export default siteScroll
